import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { PageHeader } from "@/components/StatCard";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Loader2, Save, RotateCcw } from "lucide-react";
import { TextPreview } from "@/components/TextPreview";

const FIELDS = [
  ["opening", "First text Ava sends", "Sent word-for-word as the first message to a lead. Must include the STOP opt-out.", 4],
  ["prompt", "Ava's texting instructions", "How Ava answers every reply and books appointments (phone, office or in-home).", 14],
  ["reminder", "Appointment-reminder replies", "How Ava answers when a lead replies to a reminder text.", 7],
];
const VARS = "{{customer_name}} {{lead_type}} {{mlo_name}} {{mlo_first_name}} {{mlo_nmls}} {{fit_reason}} {{text_reason}} {{office_address}}";

export default function AdminTextScript() {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/sms/scripts").then((r) => setD(r.data)).catch((e) => toast.error(apiError(e))); }, []);
  if (!d) return null;
  const set = (k, v) => setD({ ...d, scripts: { ...d.scripts, [k]: v } });
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/admin/sms/scripts", d.scripts);
      setD({ ...d, scripts: data.scripts });
      data.pushed ? toast.success("Texting script saved and sent to Retell") : toast.warning("Saved - Retell will pick it up with the next text");
    } catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };
  return (
    <div data-testid="admin-text-script-page">
      <PageHeader title="Texting Script" subtitle="What Ava says in texts sent from your Retell / Twilio texting number." />
      <Card className="p-6">
        <p className="mb-5 text-xs text-slate-500" data-testid="text-script-vars">Variables you can use: {VARS}</p>
        {FIELDS.map(([k, label, help, rows]) => (
          <div key={k} className="mb-6">
            <div className="flex items-center justify-between gap-2">
              <Label>{label}</Label>
              <Button size="sm" variant="ghost" onClick={() => set(k, d.defaults[k])} data-testid={`text-script-reset-${k}`}><RotateCcw className="mr-1 h-3.5 w-3.5" />Restore default</Button>
            </div>
            <p className="mb-1.5 text-xs text-slate-400">{help}</p>
            <Textarea rows={rows} value={d.scripts[k]} onChange={(e) => set(k, e.target.value)} data-testid={`text-script-${k}`} />
            {k === "opening" && <p className="mt-1 text-xs text-slate-400" data-testid="text-script-opening-count">{d.scripts.opening.length} / 480 characters</p>}
            {k === "opening" && <TextPreview opening={d.scripts.opening} />}
          </div>
        ))}
        <Button onClick={save} disabled={busy} data-testid="text-script-save">{busy ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <Save className="mr-1.5 h-4 w-4" />}Save texting script</Button>
      </Card>
    </div>
  );
}
